import {type FunctionalComponent, h} from '@stencil/core';
import type {GuidedApiSuggestion} from '../api';
import {Chips} from './chips';

export interface SuggestionProps{
    suggestion: GuidedApiSuggestion,
    clickHandler: CallableFunction,
}

const search_icon_svg = ()=><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M831 801c8 8 8 22 0 30-4 4-10 6-15 6-6 0-11-2-15-6L645 675c-49 42-112 67-181 67-153 0-277-125-277-278s124-277 277-277 278 124 278 277c0 69-25 132-67 181zM230 464c0 130 105 235 234 235 64 0 121-25 164-66 0-1 1-2 2-3s2-2 3-2c41-43 66-100 66-164 0-129-105-234-235-234-129 0-234 105-234 234zm234-192c12 0 22 10 22 22 0 11-10 21-22 21-82 0-149 67-149 149 0 12-10 22-21 22-12 0-22-10-22-22 0-106 86-192 192-192z"/></svg>;

export const Suggestion:FunctionalComponent<SuggestionProps> = (props) => {
    const { suggestion, clickHandler } = props;

    const icon = (quartzIcon) => quartzIcon == 'action_search_stroke'
      ? search_icon_svg()
      : <se-icon size='micro'>{quartzIcon}</se-icon>;

    return <li class="guided-pane__suggestion__section__item guided-pane_item">
      <a
        href={suggestion.openUrl}
        class="guided-pane__suggestion-link"
        onClick={(e) => clickHandler(suggestion, e, 'suggestions')}
        onContextMenu={(e) => clickHandler(suggestion, e, 'suggestions')}
      >
        <div class='guided-pane__suggestion-container'>
          {suggestion.quartzIcon ? <div class='guided-pane__quartz-icon-wrapper'>
            {icon(suggestion.quartzIcon)}
          </div> : ''}
          <p class="guided-pane__suggestion-p">
            {suggestion.chips && suggestion.chips.beforeTitle ? <Chips chips={suggestion.chips.beforeTitle} /> : ''}
            {suggestion.markup ? <span innerHTML={suggestion.markup}> </span> : suggestion.title}

            {suggestion.description ? <span class="guided-pane__suggestion-text">
              {suggestion.description}
            </span> : ''}
            {suggestion.chips && suggestion.chips.afterTitle ? <Chips chips={suggestion.chips.afterTitle}/> : ''}

          </p>
        </div>
      </a>
    </li>;
};
